import { Box, forwardRef } from '@chakra-ui/react'

export const NewReactionBadge = forwardRef((props, ref) => {
    return (
        <Box
            ref={ref}
            display="inline-block"
            borderRadius="full"
            bg="red"
            h=".5rem"
            w=".5rem"
            {...props}
        />
    )
})
